module.exports = __webpack_public_path__ + "static/media/logo_white.ab3cd426.svg";